import http from 'config/http'
import { PUBLIC_ACCESS } from 'utils/constants'
import {
  MODELS_REQUESTED,
  GET_MODELS_FAILED,
  GET_MODELS_SUCCESS,
  ARGS_MODEL_EXAMPLE,
  SAVE_PAGE_PROGRESS,
  SAVE_PAGE_STATE,
  GET_FAVOURITES_MODELS,
  FAVOURITES_MODELS_REQUESTED,
  GET_CURRENT_MODEL,
  NEGATIVE_ARGS_MODEL_EXAMPLE,
  CURRENT_MODEL_REQUESTED,
  GET_CURRENT_MODEL_FAILED,
  SET_VIEW_MODE,
} from '../types/models.type'
import { isBrowser } from 'utils/isBrowser'

export const getModelsAction = () => async (dispatch) => {
  dispatch({ type: MODELS_REQUESTED })
  const token = localStorage.getItem('session')
  try {
    const payload = await http
      .get('models/', {
        headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
      })
      .then((res) => res.data)

    dispatch({
      type: GET_MODELS_SUCCESS,
      payload,
    })
  } catch (err) {
    dispatch({ type: GET_MODELS_FAILED, payload: err?.response?.data })
  }
}
export const getModelByIdAction =
  (id, notFoundCallback = null) =>
  async (dispatch) => {
    const token = localStorage.getItem('session')
    dispatch({ type: CURRENT_MODEL_REQUESTED })
    try {
      const payload = await http
        .get(`models/${id}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
        })
        .then((res) => res.data)
      dispatch({
        type: GET_CURRENT_MODEL,
        payload: payload,
      })
      return payload
    } catch (err) {
      dispatch({ type: GET_CURRENT_MODEL_FAILED, payload: err?.response?.data })
      if (err.response && err.response.status === 404 && notFoundCallback) {
        notFoundCallback() // Trigger the callback to handle the redirection
      }
    }
  }

export const getModelResultsAction = async (id, callback) => {
  const token = localStorage.getItem('session')
  try {
    const payload = await http
      .get(`models/media/${id}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
      })
      .then((res) => res.data)
    callback(payload)
  } catch (err) {
    callback()
  }
}

export const authenticateGithub = async () => {
  try {
    // Get current page to redirect back to after auth
    const currentPath = isBrowser() ? window.location.pathname + window.location.search : '/create-models'

    // Step 1: Initiate the OAuth authentication process
    const response = await fetch(`/api/github/auth?redirectTo=${encodeURIComponent(currentPath)}`, {
      method: 'get',
    }).then((res) => res.json())

    // Step 2: Redirect the user to the GitHub authorization page
    window.location.href = response.authorizationUrl
  } catch (error) {
    console.error(error)
  }
}

export const updateModelFavourite = async (id, isFavourite, callback) => {
  const token = localStorage.getItem('session')
  try {
    const payload = await http
      .patch(
        `models/${id}/${isFavourite ? '' : 'un'}favourite`,
        {},
        {
          headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
        }
      )
      .then((res) => res.data)
    callback(payload)
  } catch (err) {
    callback(err.response?.data)
  }
}

export const getFavouriteModel = () => async (dispatch) => {
  const token = localStorage.getItem('session')
  if (!token) return null
  try {
    dispatch({ type: FAVOURITES_MODELS_REQUESTED })
    const payload = await http
      .get('models/favourites?like=false&favourite=true&follow=false', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data)
    dispatch({
      type: GET_FAVOURITES_MODELS,
      payload: payload.favourites,
    })
  } catch (err) {
    console.log(err.response?.data)
  }
}

export const saveModelPageState = (pageState) => {
  return {
    type: SAVE_PAGE_STATE,
    payload: pageState,
  }
}

export const saveModelProgress = (pageProgress) => {
  return {
    type: SAVE_PAGE_PROGRESS,
    payload: pageProgress,
  }
}

export const saveModel = (payload) => {
  return {
    type: GET_CURRENT_MODEL,
    payload,
  }
}

export const getArgsExampleAction =
  (modelId = null) =>
  async (dispatch) => {
    try {
      const payload = await fetch(`/api/supabase/model-arg-example?modelId=${modelId}`, {
        method: 'get',
      }).then((res) => res.json())
      if (payload)
        dispatch({
          type: ARGS_MODEL_EXAMPLE,
          payload,
        })
    } catch (e) {
      console.error(e)
    }
  }

export const getNegativePromptsAction =
  (modelId = null) =>
  async (dispatch) => {
    try {
      const payload = await fetch(`/api/supabase/negative-prompt-examples?modelId=${modelId}`, {
        method: 'get',
      }).then((res) => res.json())
      if (payload)
        dispatch({
          type: NEGATIVE_ARGS_MODEL_EXAMPLE,
          payload: payload,
        })
    } catch (e) {
      console.error(e)
    }
  }

export const setViewMode = (updatedViewMode) => {
  return {
    type: SET_VIEW_MODE,
    payload: updatedViewMode,
  }
}
